import React, { useEffect } from 'react'
import MetodoSolveProblems from '../../components/MetodoSolveProblems'
import BannerDevelopment from '../../components/bannerDevelopment'
import Certificados from '../../components/certificados'
import { ModeloEntrega } from '../../components/modeloEntrega'
import NossosServicos from '../../components/nossosServicos'
import Rodape from '../../components/rodape'

export default function Development() {
  useEffect(() => {
    // Check if there's a hash in the URL
    if (window.location.hash === '#modeloEntrega') {
      // Add a small delay to ensure the component is fully rendered
      setTimeout(() => {
        const element = document.getElementById('modeloEntrega')
        if (element) {
          // Scroll to the element with smooth behavior
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }, 100)
    }
  }, []) // Empty dependency array means this runs once when component mounts

    return (
        <>
            <BannerDevelopment
                title="/Development"
                backgroundUrl="../assets/banner-development.png"
                description={
                    <>
                        <span className="font-inter-bold">
                            Transformamos ideias em soluções digitais que
                            impulsionam negócios.
                        </span>{" "}
                        <br />
                        Somos especialistas em desenvolvimento completo — da criação de aplicativos
                        personalizados. Nossa expertise abrange as etapas de
                        concepção e arquitetura de software, garantindo que cada
                        solução seja robusta, escalável e verdadeiramente
                        alinhada às necessidades estratégicas dos nossos
                        clientes.
                    </>
                }
                bottomText={
                    <>
                        VERTICAL PROJECTS |{" "}
                        <span className="font-bold">be.</span>
                        hub
                    </>
                }
                bottomTextMobile="VERTICAL PROJECTS"
                brand="behub"
            />
            <MetodoSolveProblems />
            <NossosServicos 
                servicos={[
                    {
                        id: 1,
                        title: 'Desenvolvimento de Soluções',
                        image: '../assets/servicos/desenvolvimento_icon.svg',
                        link: '/desenvolvimento-de-solucoes',
                    },
                    {
                        id: 2,
                        title: 'Arquitetura de Software',
                        image: '../assets/servicos/arquitetura_icon.svg',
                        link: '/desenvolvimento-de-softwares',
                    },
                    {
                        id: 3,
                        title: 'Recuperação de Projetos​',
                        image: '../assets/servicos/recuperacao_icon.svg',
                        link: '/recuperacao-de-projetos',
                    },
                ]}
                description="Trabalhamos junto às empresas para entender seus objetivos, otimizar processos e desenvolver soluções tecnológicas escaláveis que impulsionam o crescimento e a competitividade."
                bannerImage="../assets/banner-nossos-servicos-development.png"
                bgColor="from-[#4B3BDB] via-[#A002CB] to-[#FC0021]"
            />
            <div id="modeloEntrega">
                <ModeloEntrega />
            </div>
            <Certificados text="Certificações que conquistamos" />
            <Rodape />
        </>
    );
}
